import React from 'react';
import {
  Box,
  Container,
  Flex,
  Heading,
  IconButton,
  Img,
  Text,
  Link,
} from '@chakra-ui/react';
import { FaLinkedin } from 'react-icons/fa';

const C4DPartnersBlog: React.FC = () => (
  <>
    {/* members */}
    <Flex
      as="section"
      flexDirection="column"
      overflow="hidden"
      justify="center"
      height={{ xs: '450px', sm: '300px' }}
      minH={{ xs: '450px', sm: '300px' }}
      maxH="450px"
      pos="relative"
    >
      <Img
        pos="absolute"
        objectFit="cover"
        src="/jpg/blogBanner.jpg"
        alt="members-hero"
        height="100%"
        width="100%"
      />
      <Box
        bg="linear-gradient(93.48deg, #00001F 45.8%, #186658 74.6%)"
        pos="absolute"
        height="100%"
        width="100%"
        // eslint-disable-next-line no-constant-condition
        opacity="0.7"
      />
      <Container
        maxW="container.xl"
        position="relative"
        zIndex="1"
        flexDir="column"
        px={{ xs: '20px', sm: '28px', md: '45px', lg: '60px', xl: 'inherit' }}
      >
        <Heading
          as="h1"
          mb="20px"
          variant="reportCardTitle"
          fontSize={{ xs: '26px', sm: '28px', md: '32px', lg: '38px' }}
          color="white"
          lineHeight={{ xs: '34px', md: '39px', lg: '42px' }}
        >
          Fund In Focus: C4D Partners&apos; Impact &apos;Bharat Shubharambh
          Fund&apos;, Continues to Garner Interest from global DFIs; Eyes at
          Achieving its First Close by September &apos;23
        </Heading>
        <Text
          fontSize={{ xs: '18px', sm: '18px', md: '20px', lg: '22px' }}
          fontWeight="600"
          color="white"
          lineHeight="21px"
        >
          Arvind Agarwal, Founder & CEO, C4D Partners
        </Text>
      </Container>
    </Flex>
    <Container
      as="section"
      maxW="container.xl"
      pb="80px"
      pt="40px"
      minH="420px"
      display={{ xs: 'flex', md: 'inherit' }}
      flexDirection="column"
    >
      <Box as="main" w="100%" pb="40px">
        <Text variant="blogAnswer">
          Welcome to our ‘Fund in Focus’ series where we profile our member
          funds, underscore their investment philosophy, and highlight some of
          their interesting work. Today we speak to Arvind Agarwal to learn
          about&nbsp;
          <Flex
            display="inline-flex"
            alignItems="center"
            _hover={{ textDecoration: 'underline' }}
            cursor="pointer"
          >
            <Text variant="blogAnswer" textDecor="underline">
              <a
                href="https://www.c4dpartners.com/"
                target="_blank"
                rel="noreferrer"
              >
                C4D Partners&apos;
              </a>
            </Text>
          </Flex>
          &nbsp;investment stage which is ‘similar to a VC strategy but with a
          PE approach&apos;. He further highlights in this interview how the
          fund has inculcated gender as an integral part of its investment and
          business processes and has also encouraged its portfolio companies to
          implement appropriate gender strategies for their businesses.
        </Text>
      </Box>

      <Img
        src="/webp/arvind.webp"
        alt="Arvind"
        boxSize="300px"
        float={{ xs: 'right', md: 'left' }}
        alignSelf={{ xs: 'center', md: 'flex-start' }}
        mx={{ xs: '0px', md: '0px' }}
        mr={{ xs: '0px', md: '40px', lg: '60px', xl: '70px' }}
        mb="20px"
        objectFit="cover"
      />
      <Box>
        <Flex flexDir={{ xs: 'column', lg: 'row' }} rowGap="16px">
          <Heading
            textAlign={{ xs: 'center', md: 'left' }}
            fontWeight="800"
            color="blue.400"
          >
            Spokesperson: Arvind Agarwal, Founder & CEO, C4D Partners
          </Heading>
          <Flex
            columnGap={{ xs: '4px', md: '16px' }}
            justifyContent={{ xs: 'center', md: 'flex-start' }}
            transform={{ xs: 'translateX(12px)', md: 'none' }}
          >
            <Box alignSelf="center">
              <Link
                href="https://www.linkedin.com/in/arvind-agarwal-00829110/"
                target="_blank"
              >
                <IconButton
                  aria-label="linkedin"
                  icon={
                    <FaLinkedin size="28px" color="rgba(100, 100, 140, 0.6)" />
                  }
                  variant="unstyled"
                  cursor="pointer"
                />
              </Link>
            </Box>
          </Flex>
        </Flex>
        <Box
          ml={{ xs: 'auto', md: '345px', lg: '370px' }}
          mr={{ xs: 'auto', md: '0px' }}
          width={{ xs: '160px', md: '80px' }}
          h="2px"
          bgColor="primary.500"
          borderRadius="5px"
          mt={{ xs: '16px', md: '10px' }}
          mb="15px"
        />
        <Box>
          <Heading variant="blogQuestion" pb="20px" pt="16px" pl="-20px">
            1. How would you describe C4D Partners’ investment strategy for a
            diverse market like India?
          </Heading>
          <Text variant="blogAnswer" pb="20px">
            Indian economy is driven by the Micro, Small & Medium Enterprises
            (MSME) segment. The MSMEs have been playing a remarkable role in the
            emergence of the Indian economy. India needs large investments in
            the secondary economy to boost the manufacturing segment. India can
            raise its manufacturing competitiveness and become a supplier of
            choice for its large consuming class and global markets. The
            availability of capital is the biggest obstacle to India&apos;s
            manufacturing sector. Unlike the tertiary sector, the secondary
            sector requires patient long-term investment. While the
            manufacturing sector has great potential, most investors are
            reluctant to venture, owing to the investment required in money,
            time, and effort. But this is what a developing country like India
            needs.
          </Text>
          <Text variant="blogAnswer" pb="20px">
            C4D Partners is an early-stage private equity growth fund.
            C4D&apos;s investment stage is similar to a VC strategy but with a
            PE approach. We invest in Pre-series A, Series-A, and Pre-series B
            stages. Usually, in this stage, the companies are not operationally
            positive and are looking for long-term growth capital with technical
            assistance. Therefore, at C4D Partners, we provide patient capital
            to our portfolio and emphasize guiding businesses to create a
            sustainable impact for society and have good exits for our
            investors.
          </Text>
        </Box>
        {/* Question 2 */}
        <Box pt="20px">
          <Heading variant="blogQuestion" pb="20px" pt="30px">
            2. Enterprises globally are working towards making Sustainability an
            integral part of their DNA. What, in your opinion, are the driving
            factors in India resulting in private capital being infused into
            ESG-focused enterprises?
          </Heading>
          <Box>
            <Text variant="blogAnswer" pb="16px">
              As rightly mentioned, there has been a recent surge of interest in
              ESG-focused enterprises, but we believe that ESG should already
              have been an integral part of all businesses by now. However, this
              new-found attention can be attributed to the enormous climatic
              changes that are being witnessed across the globe. As innovative
              companies are cropping up to offer solutions to these
              environmental and social challenges that are increasing by the
              day, investors are finding not just monetary value in such
              businesses but also an opportunity to generate positive social
              returns. In fact, a report by NYU Stern has stated that
              ESG-compliant companies deliver higher financial returns in the
              long run. Further, ESG-compliant companies aid in lowering the
              risk of business failure by providing downside protection,
              especially during the social or economic crisis. Therefore,
              investing in businesses that will create sustainable growth is
              only reasonable.
            </Text>
          </Box>
        </Box>

        {/* Question 3 */}

        <Box py="16px">
          <Heading variant="blogQuestion" pt="28px">
            3. C4D&apos;s existing Asia Fund has seen 42% of the AUM being
            invested in women-owned and women-led enterprises. Highlight
            interesting work by some of your portfolio companies.
          </Heading>
          <Box pt="16px">
            <Text variant="blogAnswer" pb="8px">
              At C4D Partners, gender lens is seeded in our business and
              investment processes, and one can witness it in our portfolio as
              well as in our team. We not only employ gender strategies in our
              functioning but also guide our portfolio companies to identify and
              implement appropriate gender strategies for their businesses. Most
              of our portfolio companies are highly gender responsive and have
              taken initiatives to encourage the participation of women in
              business at all levels. For instance, in a male-dominated sector
              like energy, our portfolio company Freyr Solar Energy has made
              conscious efforts to hire and retain women employees. Similarly,
              another one of our companies, Aviom Housing Finance, has dedicated
              loan services for women customers in rural areas. Through their
              initiative, Aviom Shakti they have also employed female loan
              officers to encourage women to access loans for empowering
              themselves and improving their livelihoods. Speaking of
              livelihoods, our investee company, Saahas Zero Waste, not only
              hires women employees in their factories but also pays their
              workforce higher wages than the legal mandate or even industry
              standards, thereby raising the standard of living for the
              underserved communities. We are proud to cite such initiatives by
              our investees, who are working towards achieving gender
              transformative goals and are as driven by the purpose of creating
              meaningful impact as we are.
            </Text>
          </Box>
        </Box>

        {/* Question 4 */}
        <Box py="16px">
          <Heading variant="blogQuestion" pt="16px">
            4. Recently, C4D Partners launched their maiden fund – &apos;Bharat
            Shubharambh Fund&apos; ($50M), for investments in Indian start-ups.
            Tell us how you plan to deploy this capital.
          </Heading>
          <Box>
            <Text variant="blogAnswer" py="16px">
              The C4D Bharat Shubharambh Fund is an India-dedicated early-stage
              private equity growth fund. Through this fund, we seek to
              associate with 18-20 early-stage ventures that are ESG-focused.
              This means the businesses we invest in should solve an
              environmental or societal challenge while improving livelihood
              opportunities for marginalized communities and generating returns
              for investors. Being a sector-agnostic fund, we will not have
              limitations as to which industry we would be emphasizing, but as
              has been our stance since the beginning, we would definitely look
              for impact-driven businesses rather than technology-led ones.
              Technology can surely be an enabler in the business model but not
              the lead. Also, similar to our C4D Asia fund, our first fund, we
              will continue our commitment toward women-owned/led businesses
              with at least 30% capital being deployed there.
            </Text>
          </Box>
          <Img
            mt="20px"
            src="/webp/infographic.webp"
            alt="answer-list"
            w={{ xs: '90%', md: '700px', lg: '900px' }}
            h="100%"
            mx="auto"
            mb="20px"
            objectFit="contain"
            display={{ xs: 'none', sm: 'block' }}
          />
        </Box>

        {/* Question 5 */}
        <Box pt="8" pb="20px">
          <Heading variant="blogQuestion" pb="20px" pt="12px">
            5. Any investments made so far? Will diversity play a key role in
            choosing your investee companies?
          </Heading>

          <Text variant="blogAnswer" pt="8px">
            In India, we are invested in 11 impactful businesses through our
            first fund. We have worked closely with all our portfolio companies,
            supporting their growth over the years, and we seek to amplify this
            impact through our second fund. We are currently working toward
            garnering funds for the C4D Bharat Shubharambh Fund and reaching out
            to conscious investors through our network. We are happy to share
            that we have secured much interest from DFIs across the globe and
            expect to achieve our first close by September 2023. At C4D
            Partners, we have always emphasized diversity in our processes and
            practices, and we’ll continue to follow the same in our next fund.
            As a sector-agnostic fund, we will be investing in businesses across
            sectors with a key focus on agriculture & agri-processing, energy,
            climate, retail & consumer goods, healthcare, skilling & education,
            and any other industries with a substantial impact on the
            marginalized communities and rural population of India. Furthermore,
            we also focus strongly on gender diversity, committing at least 30%
            of our funds to women-owned/led businesses. Through our first fund,
            over 42% of the AUM has been invested in women-owned/led companies
            across Asia, and with regard to the fund’s India portfolio, this
            share is over 60%.
          </Text>
        </Box>

        {/* Question 6 */}

        <Box pt="8" pb="20px">
          <Heading variant="blogQuestion" pb="20px" pt="12px">
            6. What are your thoughts on the &apos;India Opportunity &apos;
            today?
          </Heading>

          <Text variant="blogAnswer" pt="8px">
            India definitely holds immense opportunities for investors and
            businesses today to garner great returns and create meaningful
            impact. Increasing mobile and internet penetration, rapid
            urbanization, favorable government policies for businesses,
            availability of a vast talent pool, and the tremendous growth of the
            Indian economy, leading to the expansion of consumer markets in the
            country, are some significant reasons for fostering this
            development. Though most of all, it is the people bringing about
            this change. The entrepreneurial spirit that has been kindled in the
            country has encouraged many to stay in India and contribute to
            society in their own ways.
          </Text>
        </Box>

        <Box pt="8" pb="20px">
          <Heading variant="blogQuestion" pb="20px" pt="12px">
            7. Which are the hot sectors where C4D Partners will look at making
            investments in the coming year?
          </Heading>
          <Text variant="blogAnswer" pt="8px">
            We believe that climate financing will take center stage in 2023.
            Apart from the fact that enormous climatic changes are happening
            across the globe, India ranks only third after China and the US in
            carbon emissions. Since significant carbon emissions come from
            energy consumption, we see much in the clean energy market.
            Moreover, considering that India is responsible for generating 277.1
            million tonnes of waste annually, we believe that circular economy
            is another sustainable business model worth investing in. In fact,
            the Government of India has granted the maximum number of patents in
            these two segments, pushing for more technological innovations and
            the growth of green startups in clean energy and the circular
            economy.
          </Text>
        </Box>
      </Box>
      <Heading
        variant="blogQuestion"
        lineHeight="30px"
        pt="16px"
        fontStyle="italic"
        p="12px 12px 0px"
      >
        The content in this section is curated by Team IVCA. For any feedback,
        connect with&nbsp;
        <Link
          href="mailto:paromita.sinha@ivca.in"
          target="_blank"
          style={{ color: 'blue', textDecoration: 'underline' }}
        >
          paromita.sinha@ivca.in
        </Link>
      </Heading>
    </Container>
  </>
);

export default C4DPartnersBlog;
